export default {
  feedback: {
    token_required: 'Please click the checkbox to verify you are a human',
    frequent_requests:
      'Please check your SMS. We have already sent the code to the given number via SMS. If not, please check the phone number or try again in 10 minutes.',
  },
};
